import React from 'react';
import SPASelect from '@/components/admin/SysadminSPA/shared/SPASelect';
import compactSelectStyles from '@/components/admin/SysadminSPA/shared/compactSelectStyles';

interface Props {
  currentVersion: number;
  onVersionChange: (version: number) => void;
  versions: number[];
}

interface VersionOption {
  label: string;
  value: number;
}

const PromptVersionSelector = ({ currentVersion, onVersionChange, versions }: Props) => {
  const options: VersionOption[] = versions.map(version => ({ label: `v${version}`, value: version }));

  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <label className="tw-text-xs tw-text-spa-secondary" htmlFor="prompt-version-select">Version</label>
      <div className="tw-w-24">
        <SPASelect
          inputId="prompt-version-select"
          isSearchable={false}
          options={options}
          styles={compactSelectStyles}
          value={options.find(option => option.value === currentVersion) ?? null}
          onChange={(option) => { if (option) onVersionChange(option.value); }}
        />
      </div>
    </div>
  );
};

export default PromptVersionSelector;
